import { DepartmentFeatureFlags } from '@/models/api';

export function DepartmentHasFeature(value: DepartmentFeatureFlags, flag: DepartmentFeatureFlags): boolean {
    return (value & flag) === flag;
}

export function DepartmentSupportsTaskEffort(value: DepartmentFeatureFlags | null): boolean {
    return value != null && DepartmentHasFeature(value, DepartmentFeatureFlags.Maintenance);
}

export function DepartmentSupportsResourceLevelling(value: DepartmentFeatureFlags | null): boolean {
    return value != null && DepartmentHasFeature(value, DepartmentFeatureFlags.Maintenance);
}

export function DepartmentSupportsEquipmentLocations(value: DepartmentFeatureFlags | null): boolean {
    return value != null && DepartmentHasFeature(value, DepartmentFeatureFlags.Maintenance);
}

export function DepartmentSupportsFiring(value: DepartmentFeatureFlags | null): boolean {
    return value != null && !DepartmentHasFeature(value, DepartmentFeatureFlags.Maintenance);
}

export function DepartmentSupportsTaskNameExtensions(value: DepartmentFeatureFlags | null): boolean {
    return value != null && DepartmentHasFeature(value, DepartmentFeatureFlags.Maintenance);
}

export function DepartmentSupportsGroupedAdhocTasks(value: DepartmentFeatureFlags | null): boolean {
    return value != null && DepartmentHasFeature(value, DepartmentFeatureFlags.Maintenance);
}